import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class AudioEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;

    schema.register( 'audio', {
      allowWhere: ['$text', '$block'],
      allowContentOf: '$root',
      allowAttributesOf: '$text',
      inheritAllFrom: ['$text', '$block'],
      isInline: true,
      allowAttributes: ['id', 'class', 'controls', 'style', 'data-cke-ignore-events']
    } );

    editor.conversion.for('upcast').elementToElement({
      view: 'audio',
      model: (viewElement, { writer: modelWriter }) => {
      try {
        if (viewElement._children.length > 1 && viewElement._children[0]._textData.trim() === '') {
        viewElement._children[0]._remove();
        }
        return modelWriter.createElement('audio', viewElement.getAttributes());
      } catch (error) {
        console.error('Error in audio upcast conversion:', error);
        throw Error(error);
      }
      }
    });

    editor.conversion.for('downcast').elementToElement({
      model: 'audio',
      view: 'audio'
    });
  }
}
